(() => {
  const root = document.querySelector('[data-sunlife-page]');
  if (!root) return;

  const toggle = root.querySelector('.slp-menu-toggle');
  const mobileNav = root.querySelector('#slp-mobile-nav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? '開啟選單' : '關閉選單');
    if (mobileNav) mobileNav.hidden = open;
  });

  const filters = [...root.querySelectorAll('[data-product-filter]')];
  const applyFilter = (filter, updateUrl = false) => {
    if (!['all', 'care', 'fizz'].includes(filter)) filter = 'all';
    filters.forEach((item) => {
      const active = item.dataset.productFilter === filter;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      card.hidden = filter !== 'all' && card.dataset.productGroup !== filter;
    });
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.hash = filter === 'all' ? '' : filter;
      window.history.replaceState(null, '', url);
    }
  };
  filters.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.productFilter, true)));
  applyFilter(window.location.hash.slice(1));
  window.addEventListener('hashchange', () => applyFilter(window.location.hash.slice(1)));

  const sort = root.querySelector('[data-collection-sort]');
  sort?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.assign(url.toString());
  });
})();



(() => {
  const form = document.querySelector('.slp-contact-form form');
  if (!form) return;
  const params = new URL(location.href).searchParams;
  const name = params.get('product');
  const path = params.get('product_url');
  const body = form.querySelector('[name="contact[body]"]');
  if (!name || !body || body.value.trim()) return;
  let reference = '';
  if (path) {
    try {
      const url = new URL(path, location.origin);
      if (url.origin === location.origin && url.pathname.includes('/products/')) reference = decodeURI(url.href);
    } catch {}
  }
  body.value = `詢問商品：${name.slice(0,200)}${reference ? '\n商品連結：' + reference : ''}\n\n想詢問的內容：\n`;
})();
